// Check if product card headings are actually truncated
// Only show ellipsis if text overflows 3 lines

class ProductCardTruncate {
  constructor() {
    this.init();
  }

  init() {
    // Run on load
    this.checkTruncation();

    // Re-run on resize (debounced)
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.checkTruncation();
      }, 250);
    });

    // Observer for dynamically added cards (e.g., AJAX pagination, quick view)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          this.checkTruncation();
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  checkTruncation() {
    const headings = document.querySelectorAll('.card__heading');

    headings.forEach((heading) => {
      // Reset to check properly
      heading.style.webkitLineClamp = '';
      heading.style.display = '';

      // Check if content overflows
      const isOverflowing = heading.scrollHeight > heading.clientHeight;

      if (isOverflowing) {
        // Apply line clamp
        heading.style.display = '-webkit-box';
        heading.style.webkitLineClamp = '3';
      } else {
        // Remove line clamp, no truncation needed
        heading.style.webkitLineClamp = 'unset';
        heading.style.display = 'block';
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductCardTruncate();
  });
} else {
  new ProductCardTruncate();
}
